import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const ZObjectTooltip = ({tooltip, subSequence}) => { 
    if (!tooltip) {
        return '';
    }
    return (<div style={{left: tooltip.position.x, top: tooltip.position.y}} className="zobject-tooltip">
              <div className="dot"/>
              {tooltip.text}
            </div>);
}

const mapStateToProps = (state, props) => {
  return {
      tooltip: state.zobject.tooltip[props.subSequence.id]
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ZObjectTooltip);
